export const LINK_TWITTER = 'https://twitter.com/karshapana';
export const LINK_MEDIUM = 'https://karshapana.medium.com/';
export const LINK_DISCORD = 'https://discord.gg/karshapana';
export const LINK_LINKEDIN = 'https://www.linkedin.com/company/pana-dao';
export const LINK_MONA = 'https://www.instagram.com/monnerisms/?utm_medium=copy_link';
export const LINK_GITBOOK = 'https://docs.panadao.finance/';
export const LINK_GITHUB = 'https://github.com/Pana-DAO/';
export const LINK_APP = 'https://app.panadao.finance/';